// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inner-timeline {
  position: relative;
  margin-top: -10px;
  margin-bottom: 10px;
}

.timeline-container-div {
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
}

.container {
  position: relative;
  z-index: 2;
  margin: 0;
  display: grid;
  grid-auto-flow: dense;
  padding: 0;
  padding-left: 1rem;
}

.single-row {
  grid-template-columns: repeat(12, 1fr);
}

.item:nth-child(24n+24) {
  grid-column: 1;
}

.item:nth-child(24n+23) {
  grid-column: 2;
}

.item:nth-child(24n+22) {
  grid-column: 3;
}

.item:nth-child(24n+21) {
  grid-column: 4;
}

.item:nth-child(24n+20) {
  grid-column: 5;
}

.item:nth-child(24n+19) {
  grid-column: 6;
}

.item:nth-child(24n+18) {
  grid-column: 7;
}

.item:nth-child(24n+17) {
  grid-column: 8;
}

.item:nth-child(24n+16) {
  grid-column: 9;
}

.item:nth-child(24n+15) {
  grid-column: 10;
}

.item:nth-child(24n+14) {
  grid-column: 11;
}

.item:nth-child(24n+13) {
  grid-column: 12;
}

.item {
  text-align: center;
  padding: 0;
  width: 115px;
  height: 120px;
  display: flex;
  align-items: start;
  justify-content: top;
  flex-direction: column;
  padding-left: 0;
  position: relative;
}

.main-step-text {
  position: absolute;
  font-size: 9.5px;
  left: 35%;
  top: 15%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: start;
}

.progress-line {
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 1px;
  transform: translateY(-50%);
  border-top: 1px solid;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
}

.top-right-curve,
.top-right-curve-2 {
  position: absolute;
  top: 75%;
  left: 0%;
  width: 60%;
  height: 51%;
  border: 1px solid;
  border-radius: 0 80px 0 0;
  border-bottom: 0;
  border-left: 0;
  border-top: 1px solid;
  border-right: 1px solid transparent;
  transform: translateY(-50%);
}

.bottom-right-curve,
.bottom-right-curve-2 {
  position: absolute;
  top: 25%;
  left: 0%;
  width: 60%;
  height: 51%;
  border: 1px solid;
  border-radius: 0 0 80px 0;
  border-top: 1px solid transparent !important;
  border-left: 0;
  transform: translateY(-50%);
}

.top-left-curve {
  position: absolute;
  top: 75%;
  left: 41%;
  width: 60%;
  height: 51%;
  border: 1px solid;
  border-radius: 80px 0 0 0;
  border-bottom: 0;
  border-right: 0;
  border-top: 1px solid;
  border-left: 1px solid transparent;
  transform: translateY(-50%);
}

.bottom-left-curve {
  position: absolute;
  top: 25%;
  left: 41%;
  width: 60%;
  height: 50%;
  border: 1px solid;
  border-radius: 0 0 0 80px;
  border-top: 1px solid transparent !important;
  border-right: 0;
  transform: translateY(-50%);
}

.expanded-vertical-line {
  position: absolute;
  left: 1%;
  width: 0.7px;
  height: 15px;
  transform: translateX(-50%);
}

.bad-case-vertical-line {
  position: absolute;
  left: 4%;
  width: 0.7px;
  height: 15px;
  transform: translateX(-50%);
  bottom: 100%;
}

.bad-case-square {
  position: absolute;
  bottom: 100%;
  left: 4%;
  width: 15px;
  height: 15px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

.bad-case-square-text {
  margin-top: -20px;
  margin-left: 14px;
  color: #000;
  font-size: 9.5px;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
}

.square {
  position: absolute;
  bottom: -15px;
  left: 4%;
  width: 15px;
  height: 15px;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
}

.square-text {
  margin-top: 14px;
  margin-left: 14px;
  color: #000;
  font-size: 9.5px;
  display: flex;
  flex-direction: column;
  text-align: start;
  width: 60px;
}

.outer-main-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 26px;
  height: 26px;
  flex: 0 0 26px;
  box-sizing: border-box;
  z-index: 1;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.182);
}

.inner-main-circle {
  width: 23px;
  height: 23px;
  border-radius: 50%;
  border: 1px solid #ffffff;
  color: #ffffff;
  font-size: 10px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 23px;
  box-sizing: border-box;
}

.toggle-circle {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 17px;
  height: 17px;
  border-radius: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  flex: 0 0 17px;
  box-sizing: border-box;
  font-size: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-datetime {
  font-size: 7.8px;
  color: #b7b7b7;
  text-align: start;
  white-space: nowrap;
}

.conditional-offer-line-left {
  position: absolute;
  top: 50%;
  left: 0;
  width: 50%;
  height: 1px;
  transform: translateY(-50%);
  border-top: 1px solid;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
}

.conditional-offer-line-right {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 50%;
  height: 1px;
  transform: translateY(-50%);
  border-top: 1px solid;
  border-left: 0;
  border-right: 0;
  border-bottom: 0;
}

@media (min-width: 1024px) {
  .item {
    width: 95px;
  }

  .container {
    margin-left: 0px;
    padding-left: 10px;
  }
}
@media (min-width: 1366px) {
  .item {
    width: 97px;
    height: 140px;
    padding-left: 1rem;
  }

  .main-step-text {
    font-size: 11px;
    top: 18%;
  }

  .step-datetime {
    font-size: 10px;
  }

  .square-text {
    font-size: 11px;
    margin-top: 13px;
    width: 70px;
  }

  .bad-case-square-text {
    font-size: 11px;
  }

  .container {
    padding-left: 3rem;
  }
}
@media (min-width: 1920px) {
  .item {
    width: 125px;
  }

  .main-step-text {
    font-size: 12px;
    top: 16px;
    left: 40%;
  }

  .step-datetime {
    font-size: 11px;
  }

  .square-text {
    font-size: 12px;
    margin-top: 13px;
    width: 80px;
  }

  .bad-case-square-text {
    font-size: 12px;
  }

  .square {
    width: 17px;
    height: 17px;
  }

  .bad-case-square {
    width: 17px;
    height: 17px;
  }

  .expanded-vertical-line {
    height: 20x;
  }

  .container {
    padding-left: 6rem;
  }

  .inner-timeline {
    margin-bottom: 30px;
  }

  .top-right-curve,
.top-right-curve-2 {
    width: 50%;
  }

  .bottom-right-curve,
.bottom-right-curve-2 {
    width: 50%;
  }

  .top-left-curve {
    width: 50%;
    left: 50%;
  }

  .bottom-left-curve {
    width: 50%;
    left: 50%;
  }
}`, "",{"version":3,"sources":["webpack://./../job/src/components/JobOverview/InnerTimelineStep.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AACA;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;AAEF;;AACA;EACE,kBAAA;EACA,UAAA;EACA,SAAA;EACA,aAAA;EACA,qBAAA;EACA,UAAA;EACA,kBAAA;AAEF;;AACA;EACE,sCAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AAAA;EACE,cAAA;AAGF;;AADA;EACE,cAAA;AAIF;;AAFA;EACE,cAAA;AAKF;;AAHA;EACE,cAAA;AAMF;;AAJA;EACE,cAAA;AAOF;;AALA;EACE,cAAA;AAQF;;AANA;EACE,cAAA;AASF;;AAPA;EACE,cAAA;AAUF;;AARA;EACE,eAAA;AAWF;;AATA;EACE,eAAA;AAYF;;AAVA;EACE,eAAA;AAaF;;AAVA;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;AAaF;;AAVA;EACE,kBAAA;EACA,gBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAaF;;AAVA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAaF;;AARA;;EAEE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,mCAAA;EACA,2BAAA;AAWF;;AARA;;EAEE,kBAAA;EACA,QAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,4CAAA;EACA,cAAA;EACA,2BAAA;AAWF;;AARA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,qBAAA;EACA,kCAAA;EACA,2BAAA;AAWF;;AARA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,4CAAA;EACA,eAAA;EACA,2BAAA;AAWF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;AASF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,YAAA;EACA,YAAA;EACA,2BAAA;EACA,YAAA;AASF;;AANA;EACE,kBAAA;EACA,YAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AASF;;AANA;EACE,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,sBAAA;AASF;;AANA;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AASF;;AANA;EACE,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,iBAAA;EACA,WAAA;AASF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,sBAAA;EACA,UAAA;EACA,4CAAA;AASF;;AANA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,sBAAA;AASF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AASF;;AANA;EACE,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AASF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AASF;;AANA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,2BAAA;EACA,qBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AASF;;AALA;EACE;IACE,WAAA;EAQF;;EALA;IACE,gBAAA;IACA,kBAAA;EAQF;AACF;AAJA;EACE;IACE,WAAA;IACA,aAAA;IACA,kBAAA;EAMF;;EAHA;IACE,eAAA;IACA,QAAA;EAMF;;EAHA;IACE,eAAA;EAMF;;EAHA;IACE,eAAA;IACA,gBAAA;IACA,WAAA;EAMF;;EAHA;IACE,eAAA;EAMF;;EAHA;IACE,kBAAA;EAMF;AACF;AAFA;EACE;IACE,YAAA;EAIF;;EADA;IACE,eAAA;IACA,SAAA;IACA,SAAA;EAIF;;EADA;IACE,eAAA;EAIF;;EADA;IACE,eAAA;IACA,gBAAA;IACA,WAAA;EAIF;;EADA;IACE,eAAA;EAIF;;EADA;IACE,WAAA;IACA,YAAA;EAIF;;EADA;IACE,WAAA;IACA,YAAA;EAIF;;EADA;IACE,WAAA;EAIF;;EADA;IACE,kBAAA;EAIF;;EADA;IACE,mBAAA;EAIF;;EADA;;IAEE,UAAA;EAIF;;EADA;;IAEE,UAAA;EAIF;;EADA;IACE,UAAA;IACA,SAAA;EAIF;;EADA;IACE,UAAA;IACA,SAAA;EAIF;AACF","sourcesContent":[".inner-timeline {\n  position: relative;\n  margin-top: -10px;\n  margin-bottom: 10px;\n}\n.timeline-container-div {\n  display: flex;\n  flex-direction: row;\n  justify-content: start;\n  flex-wrap: wrap;\n}\n\n.container {\n  position: relative;\n  z-index: 2;\n  margin: 0;\n  display: grid;\n  grid-auto-flow: dense;\n  padding: 0;\n  padding-left: 1rem;\n}\n\n.single-row {\n  grid-template-columns: repeat(12, 1fr);\n}\n\n.item:nth-child(24n + 24) {\n  grid-column: 1;\n}\n.item:nth-child(24n + 23) {\n  grid-column: 2;\n}\n.item:nth-child(24n + 22) {\n  grid-column: 3;\n}\n.item:nth-child(24n + 21) {\n  grid-column: 4;\n}\n.item:nth-child(24n + 20) {\n  grid-column: 5;\n}\n.item:nth-child(24n + 19) {\n  grid-column: 6;\n}\n.item:nth-child(24n + 18) {\n  grid-column: 7;\n}\n.item:nth-child(24n + 17) {\n  grid-column: 8;\n}\n.item:nth-child(24n + 16) {\n  grid-column: 9;\n}\n.item:nth-child(24n + 15) {\n  grid-column: 10;\n}\n.item:nth-child(24n + 14) {\n  grid-column: 11;\n}\n.item:nth-child(24n + 13) {\n  grid-column: 12;\n}\n\n.item {\n  text-align: center;\n  padding: 0;\n  width: 115px;\n  height: 120px;\n  display: flex;\n  align-items: start;\n  justify-content: top;\n  flex-direction: column;\n  padding-left: 0;\n  position: relative;\n}\n\n.main-step-text {\n  position: absolute;\n  font-size: 9.5px;\n  left: 35%;\n  top: 15%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: start;\n  text-align: start;\n}\n\n.progress-line {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 100%;\n  height: 1px;\n  transform: translateY(-50%);\n  border-top: 1px solid;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n}\n\n// Curve Style: Start\n\n.top-right-curve,\n.top-right-curve-2 {\n  position: absolute;\n  top: 75%;\n  left: 0%;\n  width: 60%;\n  height: 51%;\n  border: 1px solid;\n  border-radius: 0 80px 0 0;\n  border-bottom: 0;\n  border-left: 0;\n  border-top: 1px solid;\n  border-right: 1px solid transparent;\n  transform: translateY(-50%);\n}\n\n.bottom-right-curve,\n.bottom-right-curve-2 {\n  position: absolute;\n  top: 25%;\n  left: 0%;\n  width: 60%;\n  height: 51%;\n  border: 1px solid;\n  border-radius: 0 0 80px 0;\n  border-top: 1px solid transparent !important;\n  border-left: 0;\n  transform: translateY(-50%);\n}\n\n.top-left-curve {\n  position: absolute;\n  top: 75%;\n  left: 41%;\n  width: 60%;\n  height: 51%;\n  border: 1px solid;\n  border-radius: 80px 0 0 0;\n  border-bottom: 0;\n  border-right: 0;\n  border-top: 1px solid;\n  border-left: 1px solid transparent;\n  transform: translateY(-50%);\n}\n\n.bottom-left-curve {\n  position: absolute;\n  top: 25%;\n  left: 41%;\n  width: 60%;\n  height: 50%;\n  border: 1px solid;\n  border-radius: 0 0 0 80px;\n  border-top: 1px solid transparent !important;\n  border-right: 0;\n  transform: translateY(-50%);\n}\n\n// Curve Style: End\n\n.expanded-vertical-line {\n  position: absolute;\n  left: 1%;\n  width: 0.7px;\n  height: 15px;\n  transform: translateX(-50%);\n}\n\n.bad-case-vertical-line {\n  position: absolute;\n  left: 4%;\n  width: 0.7px;\n  height: 15px;\n  transform: translateX(-50%);\n  bottom: 100%;\n}\n\n.bad-case-square {\n  position: absolute;\n  bottom: 100%;\n  left: 4%;\n  width: 15px;\n  height: 15px;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n}\n\n.bad-case-square-text {\n  margin-top: -20px;\n  margin-left: 14px;\n  color: #000;\n  font-size: 9.5px;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: column;\n}\n\n.square {\n  position: absolute;\n  bottom: -15px;\n  left: 4%;\n  width: 15px;\n  height: 15px;\n  transform: translateX(-50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n}\n\n.square-text {\n  margin-top: 14px;\n  margin-left: 14px;\n  color: #000;\n  font-size: 9.5px;\n  display: flex;\n  flex-direction: column;\n  text-align: start;\n  width: 60px;\n}\n\n.outer-main-circle {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  width: 26px;\n  height: 26px;\n  flex: 0 0 26px;\n  box-sizing: border-box;\n  z-index: 1;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.182);\n}\n\n.inner-main-circle {\n  width: 23px;\n  height: 23px;\n  border-radius: 50%;\n  border: 1px solid #ffffff;\n  color: #ffffff;\n  font-size: 10px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 23px;\n  box-sizing: border-box;\n}\n\n.toggle-circle {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 17px;\n  height: 17px;\n  border-radius: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n  flex: 0 0 17px;\n  box-sizing: border-box;\n  font-size: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.step-datetime {\n  font-size: 7.8px;\n  color: #b7b7b7;\n  text-align: start;\n  white-space: nowrap;\n}\n\n.conditional-offer-line-left {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  width: 50%;\n  height: 1px;\n  transform: translateY(-50%);\n  border-top: 1px solid;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n}\n\n.conditional-offer-line-right {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 50%;\n  height: 1px;\n  transform: translateY(-50%);\n  border-top: 1px solid;\n  border-left: 0;\n  border-right: 0;\n  border-bottom: 0;\n}\n\n// Laptop\n@media (min-width: 1024px) {\n  .item {\n    width: 95px;\n  }\n\n  .container {\n    margin-left: 0px;\n    padding-left: 10px;\n  }\n}\n\n// Larger Laptop Screen\n@media (min-width: 1366px) {\n  .item {\n    width: 97px;\n    height: 140px;\n    padding-left: 1rem;\n  }\n\n  .main-step-text {\n    font-size: 11px;\n    top: 18%;\n  }\n\n  .step-datetime {\n    font-size: 10px;\n  }\n\n  .square-text {\n    font-size: 11px;\n    margin-top: 13px;\n    width: 70px;\n  }\n\n  .bad-case-square-text {\n    font-size: 11px;\n  }\n\n  .container {\n    padding-left: 3rem;\n  }\n}\n\n// Desktop\n@media (min-width: 1920px) {\n  .item {\n    width: 125px;\n  }\n\n  .main-step-text {\n    font-size: 12px;\n    top: 16px;\n    left: 40%;\n  }\n\n  .step-datetime {\n    font-size: 11px;\n  }\n\n  .square-text {\n    font-size: 12px;\n    margin-top: 13px;\n    width: 80px;\n  }\n\n  .bad-case-square-text {\n    font-size: 12px;\n  }\n\n  .square {\n    width: 17px;\n    height: 17px;\n  }\n\n  .bad-case-square {\n    width: 17px;\n    height: 17px;\n  }\n\n  .expanded-vertical-line {\n    height: 20x;\n  }\n\n  .container {\n    padding-left: 6rem;\n  }\n\n  .inner-timeline {\n    margin-bottom: 30px;\n  }\n\n  .top-right-curve,\n  .top-right-curve-2 {\n    width: 50%;\n  }\n\n  .bottom-right-curve,\n  .bottom-right-curve-2 {\n    width: 50%;\n  }\n\n  .top-left-curve {\n    width: 50%;\n    left: 50%;\n  }\n  \n  .bottom-left-curve {\n    width: 50%;\n    left: 50%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
